import type { CityConfig } from "@/pages/city-template/types";

export const summervilleConfig: CityConfig = {
  city: "Summerville",
  state: "South Carolina",
  stateAbbr: "SC",
  slug: "summerville",
  route: "/summerville",
  title: "Emergency Passport Summerville, SC — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Summerville, SC — as fast as 24 hours. Fast Passport Center couriers to the Charleston Passport Center at 196 E Bay St. A+ BBB rated. Serving Dorchester County families, Flowertown travelers, Charleston metro commuters, and Lowcountry professionals.",
  h1: "Emergency & Expedited Passport Services in Summerville, SC",
  heroSubtitle: "Summerville is the charming Flowertown of the Lowcountry, one of South Carolina's fastest-growing suburbs just 25 miles from Charleston. Fast Passport Center's registered couriers deliver your documents to the Charleston Passport Center at 196 E Bay St so you get a new or renewed passport as fast as 24 hours — whether you're a Summerville family planning an overseas vacation, a Lowcountry professional heading to a European business meeting from CHS, or a Dorchester County couple booking a destination wedding.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Summerville%20South%20Carolina%20historic%20downtown%20district%20with%20Hutchinson%20Square%20fountain%20surrounded%20by%20blooming%20azalea%20gardens%20and%20towering%20live%20oak%20trees%20draped%20in%20Spanish%20moss%20during%20spring%20golden%20hour%2C%20charming%20southern%20small%20town%20streetscape%20with%20historic%20storefronts%20and%20flowering%20crepe%20myrtle%20trees%2C%20Flowertown%20charm%20with%20warm%20sunlight%20filtering%20through%20oak%20canopy&width=1800&height=700&seq=summerville-sc-hero-001&orientation=landscape",
  heroImageAlt: "Summerville South Carolina historic downtown with Hutchinson Square azaleas and live oaks at golden hour",
  geoPosition: "33.0185;-80.1758",
  geoPlacename: "Summerville, South Carolina",
  lastModified: "2026-06-14",
  regionalAgency: {
    name: "Charleston Passport Center",
    address: "196 E Bay St, Charleston, SC 29401",
    distance: "Approximately 25 miles from Summerville — about 30 minutes via I-26",
  },
  nearbyCitiesZips: [
    { name: "Summerville", zips: "29483, 29485, 29486" },
    { name: "Goose Creek", zips: "29445" },
    { name: "Ladson", zips: "29456" },
    { name: "Moncks Corner", zips: "29461" },
    { name: "North Charleston", zips: "29405, 29406, 29418" },
    { name: "Hanahan", zips: "29410" },
    { name: "Ridgeville", zips: "29472" },
    { name: "St. George", zips: "29477" },
    { name: "Harleyville", zips: "29448" },
    { name: "Walterboro", zips: "29488" },
    { name: "Charleston", zips: "29401, 29403, 29407" },
    { name: "Mount Pleasant", zips: "29464, 29466" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Courier delivery to Charleston Passport Center — serving Summerville and the Lowcountry" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-map-pin-2-line", title: "Flowertown & Dorchester County", desc: "Serving Summerville, Goose Creek, Ladson, Moncks Corner, and all Dorchester County" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your Summerville case from start to finish" },
  ],
  internalLinks: [
    { name: "Emergency passport in Charleston SC", route: "/charleston" },
    { name: "Expedited passport in Columbia SC", route: "/columbia-sc" },
    { name: "Urgent passport in Summerville SC", route: "/summerville" },
    { name: "South Carolina passport hub", route: "/south-carolina" },
    { name: "Fast passport in Mount Pleasant SC", route: "/mount-pleasant" },
    { name: "Expedited passport in Myrtle Beach SC", route: "/myrtle-beach" },
    { name: "Emergency passport in Florence SC", route: "/florence" },
  ],
  fpcOfficeAddress: "196 E Bay St, Charleston, SC 29401",
  fpcOfficeNote: "Fast Passport Center serves Summerville remotely via secure courier. Our registered couriers hand-deliver your documents to the Charleston Passport Center at 196 E Bay St — approximately 25 miles away. Summerville's location near I-26 with easy access to the Charleston metro area makes overnight courier routing highly efficient, and our dedicated agents ensure Lowcountry travelers never need to make the drive to Charleston.",
  fpcOfficeDistance: "Serving all of the Charleston metro Lowcountry region",
  serviceAreaIntro: "Fast Passport Center provides emergency and fast passport renewal services throughout Summerville, Goose Creek, Ladson, Moncks Corner, North Charleston, and the greater Dorchester County area. From Flowertown families heading overseas to Boeing and Volvo professionals traveling for business, we help Lowcountry residents get their passports fast.",
  nearbyCitiesIntro: "We serve Summerville and nearby communities including Goose Creek, Ladson, Moncks Corner, North Charleston, Hanahan, Ridgeville, and the entire Charleston metro area.",
  howItWorksIntro: "Most Summerville travelers complete everything online and ship documents overnight. Fast Passport Center provides fast courier turnaround for Lowcountry residents — with the Charleston Passport Center only 25 miles away via I-26.",
  mistakesIntro: "Summerville travelers, including Charleston metro commuters, Boeing and Volvo professionals, and Dorchester County families, face unique passport challenges. Here are the most common mistakes we see.",
  testimonialsIntro: "Summerville and Lowcountry travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Summerville? Here are the most common ones we hear from Lowcountry and Dorchester County travelers.",
  statePageRoute: "/states/south-carolina",
  statePageName: "South Carolina",
  dmvWebsite: "https://www.scdmvonline.gov/",
  dmvLabel: "South Carolina DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "No drive or appointment needed",
        "Ideal for Flowertown families headed overseas",
        "Perfect for Boeing & Volvo business travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service USPS",
        "Good for planned travel from CHS",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "No document review — errors cause rejection",
        "In-person clerk appointment required",
        "Workload shifts with government shutdowns",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "Cannot upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins at 230 Peachtree St NW",
        "Life-or-death emergencies only",
        "285 miles to Atlanta (4 hours via I-26 and I-20)",
        "Still requires pre-scheduled NPIC appointment",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "Summerville is 285 miles from the Atlanta Passport Agency — our courier service saves Lowcountry travelers the I-26 drive to Atlanta.",
      bullets: ["Lowcountry metro coverage", "24–48 hour turnaround available", "No appointment or drive needed"],
      badge: "Fastest in Lowcountry",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Summerville adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No acceptance clerk visit for most renewals", "Mail-in or courier options", "Serving Summerville and Dorchester County"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support in Summerville and Dorchester County.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Fast replacement for Summerville, Goose Creek, and Lowcountry residents with DS-64 form guidance.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement via Atlanta agency"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support in Dorchester County.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport name change service after marriage, divorce, or legal changes for Summerville and Lowcountry residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Summerville SC", description: "Urgent passport processing for Summerville, SC travelers via Atlanta Passport Agency courier — 285 miles from Summerville." },
    { name: "Passport Renewal Summerville SC", description: "Fast passport renewal for Summerville and Dorchester County, South Carolina residents." },
    { name: "New Passport Summerville SC", description: "First-time passport application assistance for Summerville and Lowcountry area residents." },
    { name: "Lost Passport Summerville SC", description: "Passport replacement for lost or stolen passports for Summerville and Lowcountry residents." },
    { name: "Child Passport Summerville SC", description: "Minor passport services for Summerville and Dorchester County families." },
    { name: "Name Change Passport Summerville SC", description: "Passport name change service for Summerville, SC residents." },
  ],
  testimonials: [
    {
      name: "Jennifer & David M.",
      location: "Summerville — Nexton Community",
      rating: 5,
      text: "We're a Summerville family that booked a dream vacation to Italy for our 20th anniversary. Realized 3 weeks out that David's passport had expired and our daughter needed a first-time passport. Fast Passport Center handled both applications — renewal in 4 days, first-time in 7. Their team was incredible.",
      service: "Family Applications",
    },
    {
      name: "William R.",
      location: "Boeing South Carolina Employee",
      rating: 5,
      text: "Boeing engineer in North Charleston called to the UK for urgent supplier meetings with 5 days notice. Passport was expired. Fast Passport Center expedited the renewal in 2 business days. Made the meetings at the Farnborough facility. Professional team that understood corporate urgency.",
      service: "Emergency Business Renewal",
    },
    {
      name: "Carolyn A.",
      location: "Summerville — Historic District Resident",
      rating: 5,
      text: "Retired teacher from Summerville who realized my passport had expired a month before a European river cruise. Fast Passport Center walked me through the entire renewal process. Had my new passport in 6 business days. Their agent was so patient and reassuring — wonderful experience.",
      service: "Senior Renewal",
    },
    {
      name: "Marcus T.",
      location: "Goose Creek, SC",
      rating: 5,
      text: "Berkeley County resident headed to Jamaica for a destination wedding. Realized 9 days before the flights that I had lost my passport. Fast Passport Center helped with the DS-64 and emergency replacement through Atlanta. Passport arrived in 4 business days. Made the wedding and was best man.",
      service: "Lost Passport Emergency",
    },
  ],
  facilities: [
    {
      id: "sum-1",
      name: "Summerville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "900 N Main St",
      city: "Summerville",
      state: "SC",
      zip: "29483",
      phone: "(843) 871-3044",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Summerville — North Main Street",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary acceptance facility for Summerville and southern Dorchester County residents. Appointment required. Located on North Main Street near downtown Summerville.",
      icon: "ri-mail-line",
    },
    {
      id: "sum-2",
      name: "Dorchester County Library — Summerville",
      type: "Public Library Passport Acceptance",
      address: "76 Old Trolley Rd",
      city: "Summerville",
      state: "SC",
      zip: "29485",
      phone: "(843) 832-3993",
      hours: "Mon–Thu: 10:00 AM – 6:00 PM, Fri–Sat: 10:00 AM – 4:00 PM",
      distance: "Summerville — Old Trolley Road",
      website: "https://www.dcl.lib.sc.us/",
      websiteLabel: "Dorchester County Library",
      notes: "Convenient library-based passport acceptance in Summerville near Oakbrook area. Evening hours on selected days. Call ahead to confirm passport service availability.",
      icon: "ri-building-line",
    },
    {
      id: "sum-3",
      name: "Goose Creek Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "307 N Goose Creek Blvd",
      city: "Goose Creek",
      state: "SC",
      zip: "29445",
      phone: "(843) 553-1574",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Goose Creek — 7 miles southeast",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Berkeley County residents in Goose Creek and Hanahan areas. Appointment recommended.",
      icon: "ri-mail-line",
    },
    {
      id: "sum-4",
      name: "Moncks Corner Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "128 N Highway 52",
      city: "Moncks Corner",
      state: "SC",
      zip: "29461",
      phone: "(843) 761-8456",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Moncks Corner — 19 miles north",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for upper Berkeley County and northern Dorchester County residents. Appointment recommended.",
      icon: "ri-mail-line",
    },
    {
      id: "sum-5",
      name: "North Charleston Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "7075 Cross County Rd",
      city: "North Charleston",
      state: "SC",
      zip: "29418",
      phone: "(843) 760-5185",
      hours: "Mon–Fri: 9:00 AM – 5:00 PM, Sat: 9:00 AM – 12:00 PM",
      distance: "North Charleston — 12 miles south",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Larger USPS location with Saturday passport hours — rare in the Lowcountry. Convenient for Ladson and southern Summerville residents.",
      icon: "ri-mail-line",
    },
    {
      id: "sum-6",
      name: "Ridgeville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "150 Church St",
      city: "Ridgeville",
      state: "SC",
      zip: "29472",
      phone: "(843) 871-2054",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Ridgeville — 8 miles north",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Small-town option for northern Dorchester County residents. Call ahead — limited hours may vary and appointments are strongly recommended.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Distance to Atlanta Agency", agency: "285 miles — 4 hour drive on I-26/I-20, but need appointment", fpc: "We drive for you — no appointment needed" },
    { feature: "Appointment Needed", agency: "Yes — call NPIC, very limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
    { feature: "Boeing & Volvo Business Support", agency: "No — generic government service", fpc: "Yes — corporate international travel expertise" },
    { feature: "Flowertown & Lowcountry Coverage", agency: "No — Lowcountry travelers must drive to Atlanta", fpc: "Yes — full Dorchester County and Charleston metro coverage" },
  ],
  mistakes: [
    {
      icon: "ri-car-line",
      title: "Assuming You Can Just Drive to Atlanta Without an Appointment",
      description: "At 285 miles, Summerville residents facing urgent travel think they can 'just drive to Atlanta.' But the Atlanta Passport Agency requires pre-scheduled NPIC appointments — absolutely no walk-ins. Appointments fill 3–4 weeks in advance during peak summer travel when Charleston metro residents are booking vacations.",
    },
    {
      icon: "ri-plant-line",
      title: "Waiting Until After the Flowertown Festival to Start Passport Planning",
      description: "Summerville's famous Flowertown Festival in spring draws huge crowds, and many families plan international summer vacations right after the festival. Waiting until April or May to start passport applications leaves little buffer for processing delays during peak season.",
    },
    {
      icon: "ri-global-line",
      title: "Boeing and Volvo Employees Not Checking Passports Before International Assignments",
      description: "The Charleston area is home to Boeing's 787 Dreamliner facility and Volvo's North American manufacturing plant. Employees called to international sites in Sweden, the UK, or Japan often don't check passport validity until days before travel. Corporate international assignments require passport validity well beyond the trip dates.",
    },
    {
      icon: "ri-image-line",
      title: "Using Chain Store Photos That Don't Meet Official Requirements",
      description: "Summerville residents sometimes get passport photos from retail chains where the technician isn't properly trained. Photos must be exactly 2x2 inches with a pure white background, neutral expression, no glasses, and no shadows. Rejected photos cause applications to be returned and processing to restart from zero.",
    },
    {
      icon: "ri-restart-line",
      title: "Not Checking Passport Validity Before Booking From CHS",
      description: "Summerville is only 15 minutes from Charleston International Airport (CHS). Lowcountry travelers often book international flights from CHS months in advance without checking passport expiration dates. Most countries require 6 months passport validity beyond your return date — airlines will deny boarding even with a valid ticket.",
    },
    {
      icon: "ri-file-list-line",
      title: "Renewing by Mail When In-Person Is Required",
      description: "Summerville residents with passports that expired more than 5 years ago, were issued under age 16, or have a name change without documentation must use Form DS-11 (in-person application) — not DS-82 (mail-in). Filing the wrong form means your application gets rejected and you start over, wasting weeks.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send a prepaid overnight label. Drop at any UPS location in Summerville, Goose Creek, or North Charleston." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team reviews every document, then couriers to the Atlanta Passport Agency — 285 miles via I-26 and I-20." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at the Atlanta Passport Agency via our pre-secured courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Summerville or Lowcountry address — fully trackable." },
  ],
  faqs: [
    {
      q: "How far is Summerville from the Atlanta passport agency?",
      a: "Summerville is approximately 25 miles from the Charleston Passport Center at 196 E Bay St — about a 30 minute drive via I-26. The Charleston Passport Center requires pre-scheduled appointments and does not accept walk-ins.",
    },
    {
      q: "Does Summerville, SC have its own passport agency?",
      a: "No. Summerville does not have a passport agency. The closest passport agency is the Charleston Passport Center at 196 E Bay St, Charleston, SC 29401 — about 25 miles away. Summerville only has passport acceptance facilities — the Summerville Post Office on North Main Street and the Dorchester County Library on Old Trolley Road — which can accept your DS-11 application but cannot process or expedite it.",
    },
    {
      q: "Where do Summerville travelers typically fly internationally?",
      a: "Summerville residents almost exclusively use Charleston International Airport (CHS), only about 15–20 minutes south via I-26. CHS offers growing international service with routes to the Caribbean, seasonal European service, and extensive domestic connections through major hubs. Some Lowcountry travelers also use Savannah/Hilton Head International (SAV, about 90 minutes away).",
    },
    {
      q: "How fast can I get an emergency passport in Summerville?",
      a: "Emergency processing is typically 24–48 hours for Summerville residents. Summerville's location in the Charleston metro area with easy access to overnight shipping hubs makes courier routing highly reliable. Standard expedited processing runs 2–9 business days. Our courier service eliminates the need to drive 285 miles to Atlanta.",
    },
    {
      q: "Where can I get passport photos in Summerville?",
      a: "Walgreens at 1600 N Main St, CVS Pharmacy at 1310 N Main St, and UPS Store locations in Summerville all offer passport photo services. There are also several pharmacies in the Nexton and Carnes Crossroads shopping areas. Always verify your photos meet exact 2x2 inch specifications with a white background.",
    },
    {
      q: "Can the Dorchester County Library process my passport?",
      a: "Yes. The Dorchester County Library at 76 Old Trolley Rd in Summerville offers passport acceptance services during select hours, including some evening availability. They can accept DS-11 applications. Call (843) 832-3993 before visiting to confirm current passport service hours — library passport services may have different schedules than regular library hours.",
    },
    {
      q: "Does the Summerville Post Office take walk-in passport appointments?",
      a: "The Summerville Post Office at 900 N Main St accepts passport applications by appointment Monday through Friday from 9:00 AM to 4:00 PM. Walk-ins are generally not accepted — call (843) 871-3044 to schedule. This location serves a growing population and can be busy, especially during spring and summer months.",
    },
    {
      q: "How do I renew my passport in Summerville?",
      a: "Adult renewals meeting all DS-82 eligibility criteria (16 or older, issued within 15 years, same name) can be done entirely by mail. Fast Passport Center's courier service achieves 2–9 business day turnaround — far faster than self-service USPS (8–11 weeks). If you're not eligible for mail-in renewal, visit the Summerville Post Office or Dorchester County Library for an in-person DS-11 application.",
    },
    {
      q: "I'm a Boeing employee — how fast can I get a passport for international travel?",
      a: "Boeing South Carolina employees at the North Charleston 787 Dreamliner facility are frequent clients for urgent international travel to supplier meetings in the UK, Japan, Sweden, and Italy. Emergency processing delivers passports in 24–48 hours. We've handled numerous Boeing employee cases and understand the documentation requirements for corporate international travel.",
    },
    {
      q: "Can Fast Passport Center help Goose Creek and Moncks Corner residents too?",
      a: "Absolutely. We serve all of the Charleston metro Lowcountry including Summerville, Goose Creek, Ladson, Moncks Corner, North Charleston, Hanahan, Ridgeville, St. George, Walterboro, and all of Dorchester and Berkeley counties. Residents of surrounding communities never need to drive to Summerville or Atlanta for service.",
    },
    {
      q: "Is there an acceptance facility open on Saturday near Summerville?",
      a: "Yes. The North Charleston Main Post Office at 7075 Cross County Rd offers Saturday passport acceptance from 9:00 AM to 12:00 PM — one of the few Saturday options in the Charleston metro area. It's about a 15-minute drive from Summerville. The Summerville Post Office and Dorchester County Library do not offer Saturday hours for passport services.",
    },
    {
      q: "I'm planning a destination wedding — when should I start the passport process?",
      a: "Summerville is a popular wedding destination, and many local couples choose international destination weddings in the Caribbean, Mexico, or Europe. Start passport applications at least 4–6 months before the wedding. This allows time for both passport and any required visas for the destination, plus time for name change passport updates after the wedding if needed.",
    },
  ],
  photoLocations: [
    { name: "Walgreens — Summerville", address: "1600 N Main St, Summerville, SC 29483", hours: "Mon–Sun: 7AM–10PM" },
    { name: "CVS Pharmacy — Summerville", address: "1310 N Main St, Summerville, SC 29483", hours: "Mon–Sun: 8AM–9PM" },
    { name: "UPS Store — Summerville (Nexton)", address: "111-A Nexton Square Dr, Summerville, SC 29486", hours: "Mon–Fri: 8AM–6PM, Sat: 9AM–2PM" },
    { name: "Walmart Photo — Summerville", address: "1318 N Main St, Summerville, SC 29483", hours: "Mon–Sun: 7AM–9PM" },
    { name: "Walgreens — Goose Creek", address: "215 St James Ave, Goose Creek, SC 29445", hours: "Mon–Sun: 7AM–10PM" },
    { name: "CVS Pharmacy — North Charleston", address: "7555 Dorchester Rd, North Charleston, SC 29418", hours: "Mon–Sun: 8AM–9PM" },
  ],
  dmvLocations: [
    { name: "SC DMV — Summerville", address: "1341 College Park Rd, Summerville, SC 29486", hours: "Mon–Fri: 8:30AM–5:00PM", note: "Primary SC DMV branch serving Summerville and Dorchester County residents. Located in the Nexton area near I-26. REAL ID, driver's license, and state ID services.", featured: true },
    { name: "SC DMV — North Charleston", address: "3811 Leeds Ave, North Charleston, SC 29405", hours: "Mon–Fri: 8:30AM–5:00PM", note: "Major DMV branch serving the Charleston metro area. About 15 minutes from Summerville via I-26. Full service including REAL ID.", featured: false },
    { name: "SC DMV — Moncks Corner", address: "223 N Live Oak Dr, Moncks Corner, SC 29461", hours: "Mon–Fri: 8:30AM–5:00PM", note: "Serves Berkeley County and northern Summerville area residents. Convenient for those near the Berkeley County line.", featured: false },
  ],
  airports: [
    {
      code: "CHS",
      name: "Charleston International Airport",
      distance: "15 miles south of Summerville",
      address: "5500 International Blvd, North Charleston, SC 29418",
      note: "The primary airport serving Summerville and the Lowcountry. Only 15–20 minutes via I-26. Growing international service to the Caribbean, seasonal European routes, and extensive domestic connections via all major carriers. Boeing's 787 assembly facility is adjacent to the airport.",
      flightUrl: "https://www.iflychs.com/",
      flightLabel: "CHS Airport",
      featured: true,
    },
    {
      code: "SAV",
      name: "Savannah/Hilton Head International Airport",
      distance: "90 miles south of Summerville",
      address: "400 Airways Ave, Savannah, GA 31408",
      note: "Regional airport serving Savannah and the Lowcountry with domestic routes and some seasonal international service. About 1 hour 40 minutes via I-95. Alternative for southern Lowcountry residents.",
      flightUrl: "https://savannahairport.com/",
      flightLabel: "SAV Airport",
      featured: false,
    },
    {
      code: "CAE",
      name: "Columbia Metropolitan Airport",
      distance: "90 miles northwest of Summerville",
      address: "3250 Airport Blvd, West Columbia, SC 29170",
      note: "South Carolina's second-busiest airport with domestic routes via major carriers. About 1 hour 30 minutes via I-26. Alternative for Midlands residents who don't want to use CHS.",
      flightUrl: "https://flycae.com/",
      flightLabel: "CAE Airport",
      featured: false,
    },
    {
      code: "CLT",
      name: "Charlotte Douglas International Airport",
      distance: "180 miles north of Summerville",
      address: "5501 R C Josh Birmingham Pkwy, Charlotte, NC 28208",
      note: "Major international hub with the most extensive international route network accessible to Lowcountry travelers. About 3 hours via I-26 and I-77. American Airlines hub with worldwide connections.",
      flightUrl: "https://www.cltairport.com/",
      flightLabel: "CLT Airport",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    { icon: "ri-user-smile-line", label: "Birth & Death Certificates", desc: "Order certified South Carolina birth and death certificates from the SC Department of Health and Environmental Control Vital Records — online, by mail, or in person.", url: "https://scdhec.gov/vital-records" },
    { icon: "ri-hearts-line", label: "Marriage Records", desc: "Request certified marriage certificates from the Dorchester County Probate Court. Required for name change passport applications.", url: "https://www.dorchestercountysc.gov/" },
    { icon: "ri-file-copy-line", label: "Divorce Decrees", desc: "Obtain certified divorce records through the Dorchester County Family Court. Required for name change passport corrections.", url: "https://www.sccourts.org/" },
    { icon: "ri-global-line", label: "VitalChek — Nationwide Records", desc: "If your record was issued outside South Carolina, order certified copies online through VitalChek for delivery in 5–10 business days.", url: "https://www.vitalchek.com/" },
  ],
};